'use strict';

Object.defineProperty(exports, "__esModule", {
		value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getAllMatchingJobs = require('shared/utils/getAllMatchingJobs');

var _getAllMatchingJobs2 = _interopRequireDefault(_getAllMatchingJobs);

var _actions = require('../../components/MatchTooltip/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import objAsArray from 'shared/utils/objAsArray';
//import arrayAsObj from 'shared/utils/arrayAsObj';
var getJobsInSubsector = function getJobsInSubsector(jobs, subsector) {
		return jobs.filter(function (job) {
				return job.subsector === subsector;
		});
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref, _ref2) {
		var _ref$data = _ref.data,
		    subsectors = _ref$data.subsectors,
		    jobs = _ref$data.jobs,
		    skills = _ref$data.skills,
		    interests = _ref$data.interests,
		    educationLevels = _ref$data.educationLevels,
		    user = _ref.user;
		var columns = _ref2.columns;

		var jobsWithMatch = (0, _getAllMatchingJobs2.default)({
				user: user,
				data: {
						jobs: jobs,
						skills: skills,
						interests: interests,
						educationLevels: educationLevels
				}
		}).map(function (j) {
				return (0, _extends3.default)({}, j, {
						subsector: (subsectors[j.subsectors[0]] || {}).slug || '',
						match: j.matches.match,
						salary: j.salary || 'no salary provided'
						//description: j.shortDesc,
				});
		});

		return {
				hasMatched: user.hasMatched,
				columns: columns.map(function (_ref3) {
						var id = _ref3.id,
						    image = _ref3.image;

						var subsector = subsectors[id];
						return {
								id: id,
								image: image,
								title: subsector.contentTitle || '',
								jobs: getJobsInSubsector(jobsWithMatch, subsector.slug)
								/*
           jobs: [
             {
               match: 0.85,
               title: 'Senior Financial Analyst',
               salary: '55k - 65k',
             },
             {
               match: 0.75,
               title: 'Senior Financial Analyst 2',
               salary: '55k - 65k',
             },
             {
               match: 0.45,
               title: 'Senior Financial Analyst 3',
               salary: '55k - 65k',
             },
             {
               match: 0.55,
               title: 'Senior Financial Analyst 4',
               salary: '55k - 65k',
             },
           ],
        */
						};
				})
		};
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
				matchMe: function matchMe(shouldOpen) {
						return dispatch((0, _actions.matchMe)(shouldOpen));
				}
		};
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/RolesAndEducation/selectors.js
// module id = 1263
// module chunks = 0